import React, { useLayoutEffect } from 'react';

import { Box } from '@rbilabs/universal-components';
import Animated, {
  FadeIn,
  LayoutAnimationConfig,
  SlideInLeft,
  SlideInRight,
} from 'react-native-reanimated';

import { useProductWizardFlow } from 'pages/menu/components/product-wizard/use-product-wizard-flow';

import { useProductWizardContext } from '../product-wizard';

import { ProductCustomization } from './product-customization';
import { CloseConfirmationDialog } from './product-detail-flow/dialogs/close-confirmation-dialog';
import { UnsavedChangesDialog } from './product-detail-flow/dialogs/unsaved-changes-dialog';
import { ProductHome } from './product-home';
import {
  ProductDetailFlowContent,
  getBackgroundColorByStep,
  productDetailFlowContainerStyles,
} from './styled';
import { isCustomization } from './utils';

export const FADE_IN_ANIMATION_DURATION = 700;
export const SLIDE_IN_ANIMATION_DURATION = 300;

export const ProductDetail = () => {
  const { currentFlowStep } = useProductWizardFlow();
  const { flowDirection } = useProductWizardContext();

  const isMountedRef = React.useRef<boolean>(false);

  const Animation = flowDirection === 'backward' ? SlideInLeft : SlideInRight;

  const productDetailFlowKey = `${currentFlowStep.step}-${currentFlowStep.slotKey}-${flowDirection}`;

  // LayoutAnimationConfig skipEntering alternative logic for web devices
  useLayoutEffect(() => {
    isMountedRef.current = true;
  });

  return (
    <Box testID="product-detail" flex={1}>
      <LayoutAnimationConfig skipEntering>
        <Animated.View
          key={productDetailFlowKey}
          style={productDetailFlowContainerStyles}
          entering={FadeIn.duration(FADE_IN_ANIMATION_DURATION)}
        >
          <Animated.View
            entering={
              isMountedRef.current ? Animation.duration(SLIDE_IN_ANIMATION_DURATION) : undefined
            }
            style={{
              ...productDetailFlowContainerStyles,
              backgroundColor: getBackgroundColorByStep(currentFlowStep.step),
            }}
          >
            <ProductDetailFlowContent testID="product-detail-flow-content">
              <ProductDetailStep />
            </ProductDetailFlowContent>
          </Animated.View>
        </Animated.View>
      </LayoutAnimationConfig>

      <CloseConfirmationDialog />
      <UnsavedChangesDialog />
    </Box>
  );
};

const ProductDetailStep = () => {
  const { currentFlowStep } = useProductWizardFlow();

  if (isCustomization(currentFlowStep.step)) {
    return <ProductCustomization />;
  }

  return <ProductHome />;
};
